export function isSupportedOvertimeTimesheetDuration(duration) {
    return duration === 1 || duration === 7;
}
export function summarizeOvertimeBreakdown(overtimeBreakdown) {
    const breakdownByTimeType = new Map();
    let hasOvertimeData = false;
    for (const dayBreakdown of Object.values(overtimeBreakdown)) {
        for (const entry of dayBreakdown) {
            hasOvertimeData ||=
                entry.currentAppliedDuration !== 0 ||
                    entry.overappliedDuration !== 0 ||
                    entry.underappliedDuration !== 0;
            const existingEntry = breakdownByTimeType.get(entry.timeTypeId);
            if (existingEntry) {
                existingEntry.currentAppliedDuration += entry.currentAppliedDuration;
                existingEntry.incorrectlyAppliedDuration +=
                    entry.overappliedDuration - entry.underappliedDuration;
            }
            else {
                breakdownByTimeType.set(entry.timeTypeId, {
                    timeTypeId: entry.timeTypeId,
                    timeTypeName: entry.timeTypeName,
                    currentAppliedDuration: entry.currentAppliedDuration,
                    incorrectlyAppliedDuration: entry.overappliedDuration - entry.underappliedDuration,
                });
            }
        }
    }
    return {
        breakdownByTimeType,
        hasOvertimeData,
        hasDiscrepancies: [...breakdownByTimeType.values()].some((entry) => entry.incorrectlyAppliedDuration !== 0),
    };
}
//# sourceMappingURL=overtime.js.map